<template>
  <v-dialog v-model="dialogModel" max-width="600px">
    <v-card>
      <v-form :ref="dialogType === 'ama' ? 'formAMA' : 'formD14'" :name="dialogType === 'ama' ? 'formAMA' : 'formD14'">
        <v-card-title>
          <span class="headline">{{ form.titleForm || form.formName }}</span>
        </v-card-title>
        <v-card-text v-if="!showAmaInfo">
          <v-row no-gutters class="mt-2">
            <v-col md="12" cols="12" class="mb-3">
              <span v-if="form.formName === 'AMA'">
                {{  $tc('membership.ama_link_description') }}
                <a href="https://americanmotorcyclist.com/join-the-ama/" target="_blank">https://americanmotorcyclist.com/join-the-ama/</a>
              </span>
              <div class="d-flex align-center">                      
                <v-text-field
                  :value="form.memberId"
                  @input="handleMemberIdUpdate"
                  :label="$tc('membership.membership_number')"
                  outlined dense
                  hide-details
                  class="mr-2"
                  @keydown.enter.prevent="handleValidate"
                ></v-text-field>
                <v-btn
                  @click="handleValidate"
                  :color="`${buttonColor}`"
                  :disabled="!form.memberId"
                  class="btn"
                >{{ $tc('membership.validate') }}</v-btn>
              </div>
              <p class="mb-0" v-if="!form.memberId && !errorAmaMsg">{{ $tc('membership.ama_validate_description') }}</p>
              <p v-if="errorAmaMsg" class="error-message mb-0" v-html="errorAmaMsg"></p>              
            </v-col>
            <v-col md="12" cols="12" v-if="numberAvailable">
              <div class="d-flex align-center">
                <v-icon class="mr-2">mdi-calendar</v-icon>
                <span class="text-grey-darken-1">{{ $tc('membership.membership_expiration') }}</span>
                <span class="ml-2 font-weight-bold">{{ form.expirationDate | formatDateForHumans(false) }}</span>
                <span class="ml-2 text-weight-bold" v-if="form.lifemembercheckbox">{{ $tc('membership.lifetime_member') }}</span>
              </div>
            </v-col>
          </v-row>
        </v-card-text> 
        <v-card-text v-else>
          <v-row>
              <v-col cols="12" class="py-0">
                <p class="mb-0">{{ $tc('membership.ama_profile_difference') }}</p>              
              </v-col>
              <v-col cols="12">
                <h3 class="mb-1">{{ $tc('membership.information_comparison') }}</h3>
                <v-data-table 
                dense
                :headers="membershipHeaders" 
                hide-default-footer 
                :items="membershipItems">            
                </v-data-table>
              </v-col>
              <v-col cols="12" class="pt-0">
                <div class="warning-box">                  
                  <h3 class="mb-1 d-flex align-center">
                    <v-icon left color="warning" class="warning-icon mr-2">mdi-alert</v-icon>
                    {{ $tc('membership.notice') }}
                  </h3>
                  <p class="mb-0 d-flex align-center" v-html="$tc('membership.notice_content')">
                  </p>
                </div>
              </v-col>
              <v-col cols="12" class="mb-0 pb-0" v-if="isAccountManager">
                <v-btn :color="buttonColor" class="btn-responsive" :disabled="loading" @click="handleGoToProfileAMA">{{ $tc('membership.btn_update_ama_information') }}</v-btn>
              </v-col>
              <v-col cols="12" class="pb-0" v-if="isAccountManager">
                <v-btn :color="buttonColor" class="btn-responsive" :disabled="loading" @click="handleUpdateProfile">{{ $tc('membership.btn_update_livelaps_account_to_match_ama') }}</v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn :color="buttonDangerColor" class="btn-responsive" :disabled="loading" @click="handleCancel">{{ $tc('membership.cancel') }}</v-btn>
              </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-start px-4 pb-4" v-if="!showAmaInfo">
            <v-btn
              @click="handleCancel"
              :color="`${buttonColor}`"
              class="btn mr-2"
            >{{ $tc('membership.cancel') }}</v-btn>
            <v-btn
              :color="`${buttonColor}`"
              class="btn"
              :disabled="!numberAvailable"
              @click="handleSave"
            >{{ $tc('membership.save') }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { VDialog, VCard, VCardActions, VForm, VBtn, VCardText, VCardTitle, VTextField, VRow, VCol, VIcon, VDataTable } from 'vuetify/lib';
export default {
  name: "MembershipDialog",
  components:{
    VDialog, VCard, VForm, VBtn, VCardText, VCardTitle, VTextField, VCardActions, VRow, VCol, VIcon, VDataTable,
  },
  props: {
    value: { type: Boolean, default: false },
    dialogType: { type: String, default: 'ama' }, // 'ama' or 'd14'
    form: { type: Object, required: true },
    rules: { type: Object, default: () => ({}) },
    buttonColor: { type: String, default: "primary" },
    buttonDangerColor: { type: String, default: "error" },
    numberAvailable: { type: Boolean, default: false },
    errorAmaMsg: { type: String, default: "" },
    btnUpdateProfile: { type: String, default: "" },
    showAmaInfo: { type: Boolean, default: false },
    isAccountManager: { type: Boolean, default: true },
    membershipItems: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },
  computed: {
    dialogModel: {
      get() {
        return this.value
      },
      set(v) {
        if (!v) {
          this.$emit('input', false)
        }
      }
    },
    membershipHeaders() {
      return [
        { text: this.$t("membership.field"), value: "field" },
        { text: this.$t("membership.ama_record"), value: "amaRecord" },
        { text: this.$t("membership.livelaps_profile"), value: "livelapsProfile" }
      ]
    },
  },
  methods: {
    handleMemberIdUpdate(value) {
      this.$emit('update:memberId', value)
    },
    handleCancel() {
      const formRef = this.dialogType === 'ama' ? this.$refs.formAMA : this.$refs.formD14
      if (formRef) {
        formRef.reset()
      }
      this.$emit('input', false)
      this.$emit('cancel')
    },
    handleValidate() {
      this.$emit('validate')
    },
    handleSave() {
      if (this.dialogType === 'ama') {
        this.$emit('add')
      } else {
        this.$emit('save-d14')
      }
    },
    handleUpdateProfile() {
      this.$emit('update-profile')
    },
    handleGoToProfileAMA() {
      const formRef = this.dialogType === 'ama' ? this.$refs.formAMA : this.$refs.formD14
      if (formRef) {
        formRef.reset()
      }
      this.$emit('go-to-profile')
    }
  }
}
</script>

<style scoped>
.v-btn, .v-btn__content {
  color: white !important;
}
.error-message {
  color: red;
  font-size: 14px;
}

.warning-box {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
  padding: 12px;
  border-radius: 6px;
}

.warning-icon {
  font-size: 20px;
  line-height: 1;
}

@media (max-width: 599px) {
  .btn-responsive {
    height: auto !important;
    min-height: 36px;
    padding: 8px 12px !important;
    max-width: 100%;
    width: 100%;
  }
  .btn-responsive >>> .v-btn__content {
    white-space: normal;
    flex: 1 1 auto;
    display: block;
    line-height: 1.2;
    text-align: center;
  }
}
</style>